import { useCoBranding } from '../hooks/useCoBranding';
import { useParamsQuery } from '../hooks/useQueries';

const RedirectToConstructionFunnel = () => {
  const activities = useParamsQuery().data?.activities ?? [];
  const { partnerName } = useCoBranding();

  const url = new URL('https://decennale.insify.fr');
  const searchParams = new URLSearchParams();

  const activityCodes = activities.map(({ insifyActivityCode }) => insifyActivityCode);
  activityCodes.forEach((activityCode) => searchParams.append('activityCode', activityCode));

  if (partnerName !== undefined) {
    searchParams.append('partner', partnerName);
  }

  url.search = searchParams.toString();

  window.location.replace(url.href);

  return null;
};

export { RedirectToConstructionFunnel };
